import { useMemo, useState } from "react";
import { Link } from "react-router-dom";
import { searchEvents } from "@/utils/events";

const hotKeywords = ["英雄联盟", "马拉松", "围棋", "滑板", "国际赛事"];

export default function EventSearch() {
  const [keyword, setKeyword] = useState("");
  const [focused, setFocused] = useState(false);

  const results = useMemo(() => searchEvents(keyword, 6), [keyword]);
  const showDrops = focused && keyword.trim().length > 0;

  return (
    <div className="relative z-20 mx-auto -mt-10 w-full max-w-[1100px] px-4 md:px-6">
      <div className="rounded-lg border border-background-200 bg-background-50 p-5 md:p-6">
        <div className="flex flex-col gap-3 md:flex-row md:items-center">
          <div className="flex items-center gap-3 rounded-md border border-background-300 bg-background-100 px-4 py-3 md:flex-1">
            <i className="ri-search-2-line text-lg text-foreground-500"></i>
            <input
              value={keyword}
              onChange={(e) => setKeyword(e.target.value)}
              onFocus={() => setFocused(true)}
              onBlur={() => setTimeout(() => setFocused(false), 150)}
              placeholder="输入赛事名称、项目或地区关键词，例如“英雄联盟”“马拉松”"
              className="w-full bg-transparent text-sm text-foreground-900 outline-none placeholder:text-foreground-400"
            />
            {keyword && (
              <button
                type="button"
                onClick={() => setKeyword("")}
                aria-label="清空搜索"
                className="flex h-6 w-6 items-center justify-center rounded-full text-foreground-500 hover:bg-background-200"
              >
                <i className="ri-close-circle-line"></i>
              </button>
            )}
          </div>
          <Link
            to={keyword.trim() ? `/category?q=${encodeURIComponent(keyword.trim())}` : "/category"}
            className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
          >
            <i className="ri-search-line"></i>
            搜索赛事
          </Link>
        </div>

        <div className="mt-4 flex flex-wrap items-center gap-2 text-xs">
          <span className="text-foreground-500">热门搜索：</span>
          {hotKeywords.map((word) => (
            <button
              key={word}
              type="button"
              onClick={() => setKeyword(word)}
              className="rounded-full bg-secondary-100 px-3 py-1 font-medium text-secondary-800 transition-colors hover:bg-secondary-200"
            >
              {word}
            </button>
          ))}
        </div>

        {showDrops && (
          <div className="absolute left-4 right-4 top-full z-30 mt-2 overflow-hidden rounded-lg border border-background-200 bg-background-50 md:left-6 md:right-6">
            {results.length > 0 ? (
              <ul className="max-h-96 overflow-y-auto">
                {results.map((event) => (
                  <li key={event.id}>
                    <Link
                      to={`/detail/${event.id}`}
                      className="flex items-center gap-3 border-b border-background-100 px-4 py-3 transition-colors last:border-b-0 hover:bg-background-100"
                    >
                      <div className="h-12 w-16 shrink-0 overflow-hidden rounded bg-background-200">
                        <img
                          src={event.cover}
                          alt={`${event.title} 赛事封面`}
                          title={`${event.title} 赛事资讯`}
                          className="h-full w-full object-cover object-top"
                        />
                      </div>
                      <div className="min-w-0 flex-1">
                        <p className="truncate text-sm font-medium text-foreground-950">
                          {event.title}
                        </p>
                        <p className="mt-0.5 truncate text-xs text-foreground-500">
                          {event.category} · {event.region} · {event.date}
                        </p>
                      </div>
                      <i className="ri-arrow-right-s-line text-foreground-400"></i>
                    </Link>
                  </li>
                ))}
              </ul>
            ) : (
              <div className="px-4 py-6 text-center text-sm text-foreground-500">
                未找到与「{keyword}」相关的赛事，试试更换关键词
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
}